"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _providerComponents = require("@kyruus/provider-components");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _styles = require("./styles");
var _provider = require("../../lib/provider");
var _configUtils = require("../../lib/config-utils");
var _globals = require("../../lib/constants/globals");
var _availability = require("../../lib/availability");
var _providerBadges = _interopRequireDefault(require("../ProviderBadges/provider-badges"));
var _ProviderBooking = require("../ProviderBooking");
var _providerImage = _interopRequireDefault(require("../ProviderImage/provider-image"));
var _providerLogos = _interopRequireDefault(require("../ProviderLogos/provider-logos"));
var _providerProfileLink = _interopRequireDefault(require("../ProviderProfileLink/provider-profile-link"));
var _providerRating = _interopRequireDefault(require("../ProviderRating/provider-rating"));
var _providerSummary = _interopRequireDefault(require("../ProviderSummary/provider-summary"));
var _virtualProviderDogEarBanner = _interopRequireDefault(require("../VirtualProviderDogEarBanner/virtual-provider-dog-ear-banner"));
var _booking = require("../../lib/booking");
var _ProviderCardTabs = require("../ProviderCardTabs");
/* eslint-disable react/prop-types */
const ProviderCard = _ref => {
  let {
    provider,
    providerLocations,
    bookOnlineUrl,
    config,
    searchSummary,
    track,
    bookingCallback,
    reviewCallback,
    summaryCallback,
    apptInfo,
    onClickShowAvailability,
    availabilityTilesMessages,
    reviewUrl,
    summaryUrl,
    lazyLoadImg,
    shouldDisplayAvailability,
    availabilityLinkTarget,
    onTimeSlotsClick,
    onViewMoreClick,
    onAvailabilityTilesLoaded,
    slots,
    slotsStatus,
    getLocationUrl,
    locationCallback,
    locationCTA,
    locationsUrl,
    locationsCallback,
    customerCode,
    placementType,
    bookingWarning,
    applyV9SummaryData,
    hasBookingWarning = false,
    isBookingDisabled,
    productName,
    isProfileDisabled = false,
    slotsAriaProps,
    bookingOptionsButton
  } = _ref;
  const trackProvider = function (message) {
    let event_data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return track?.(message, {
      ...event_data,
      provider_id: provider.id
    });
  };
  const isAvailabilityReadOnly = (0, _get2.default)(config, 'enable_read_only_availability', false);
  const providerCardTabsConfig = (0, _get2.default)(config, 'provider_tile.provider_card_tabs', []);
  const isHeadsUpAvailabilityEnabled = (0, _get2.default)(config, 'darkship_feature_flags.provider_tile_heads_up_availability', false);
  const shouldDisplayAvailabilityWithLocations = isHeadsUpAvailabilityEnabled === false && shouldDisplayAvailability;
  const providerTabsEnabled = Boolean(providerCardTabsConfig.is_enabled);
  const shouldDisplayFaxNumber = Boolean(config.provider_tile?.enable_fax_number);
  const shouldRenderSlotsAsButtons = config.direct_book?.render_type === 'drawer' || isHeadsUpAvailabilityEnabled;
  const LocationsProps = {
    locations: providerLocations,
    config,
    searchSummary,
    track,
    bookingCallback,
    reviewCallback,
    reviewUrl,
    summaryCallback,
    lazyLoadImg,
    onClickShowAvailability,
    availabilityTilesMessages,
    summaryUrl,
    shouldDisplayAvailability: shouldDisplayAvailabilityWithLocations,
    isAvailabilityReadOnly,
    availabilityLinkTarget,
    onAvailabilityTilesLoaded,
    onTimeSlotsClick,
    onViewMoreClick,
    shouldRenderSlotsAsButtons,
    apptInfo,
    slots,
    slotsStatus,
    getLocationUrl,
    locationCallback,
    locationCTA,
    bookOnlineUrl,
    shouldDisplayFaxNumber,
    // if a customer sets this configuration to the value `false` in the config, then the feature will be turned off
    // otherwise it will default to 'on'
    prioritizeDistance: config.provider_tile?.prioritize_distance !== false,
    locationsUrl,
    locationsCallback,
    ariaProps: {
      locationsAriaLabeledBy: `view-details-${provider.id}`
    },
    enableLocationsLimit: isProfileDisabled === false && locationCTA == null
  };
  const providerDisplayName = (0, _provider.getProviderDisplayName)(provider);
  const showBooking = (0, _booking.shouldShowBooking)(provider, config.modal_display);
  const showVirtualDogEarBanner = (0, _get2.default)(config, 'provider_tile.show_virtual_provider_dog_ear_banner', false);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_styles.ProviderContainer, {
    providerTabsEnabled: providerTabsEnabled,
    "data-view": "consumer-provider",
    "data-testid": "ProviderCard",
    id: provider.id,
    showBooking: showBooking,
    isHeadsUpAvailabilityEnabled: isHeadsUpAvailabilityEnabled
  }, showVirtualDogEarBanner ? /*#__PURE__*/_react.default.createElement(_virtualProviderDogEarBanner.default, {
    provider: provider,
    config: config
  }) : null, /*#__PURE__*/_react.default.createElement(_styles.ProviderImages, {
    "data-testid": "ProviderImage"
  }, /*#__PURE__*/_react.default.createElement(_providerImage.default, {
    provider: provider,
    summaryCallback: summaryCallback,
    summaryUrl: summaryUrl,
    track: trackProvider,
    lazyLoadImg: lazyLoadImg,
    isProfileDisabled: isProfileDisabled,
    config: config
  }), /*#__PURE__*/_react.default.createElement(_providerLogos.default, {
    provider: provider,
    logoConfigs: (0, _configUtils.backwardsCompatibleGetLogoConfigs)(config),
    facets: (0, _configUtils.backwardsCompatibleGetFacets)(config)
  })), /*#__PURE__*/_react.default.createElement(_styles.ProviderInfo, null, /*#__PURE__*/_react.default.createElement(_styles.ProviderName, {
    disabled: isProfileDisabled
  }, isProfileDisabled ? providerDisplayName : /*#__PURE__*/_react.default.createElement(_providerProfileLink.default, {
    id: "view-details",
    provider: provider,
    pageSection: _globals.LOGGING.PAGE_SECTION.PROVIDER_NAME,
    navCallback: summaryCallback,
    navUrl: summaryUrl,
    track: trackProvider
  }, providerDisplayName)), /*#__PURE__*/_react.default.createElement(_providerBadges.default, {
    config: config,
    provider: provider,
    badgeFields: (0, _configUtils.backwardsCompatibleGetBadgeFields)(config)
  }), /*#__PURE__*/_react.default.createElement(_providerRating.default, {
    provider: provider,
    reviewCallback: reviewCallback,
    reviewUrl: reviewUrl,
    isProfileDisabled: isProfileDisabled,
    track: trackProvider
  }), /*#__PURE__*/_react.default.createElement(_providerSummary.default, {
    provider: provider,
    summaryData: (0, _configUtils.backwardsCompatibleGetSummaryData)(config, applyV9SummaryData),
    facets: (0, _configUtils.backwardsCompatibleGetFacets)(config)
  })), showBooking && /*#__PURE__*/_react.default.createElement(_ProviderBooking.ProviderBooking, {
    apptInfo: apptInfo,
    provider: provider,
    modalDisplay: config.modal_display,
    bookingCallback: bookingCallback,
    shouldDisplayAvailability: shouldDisplayAvailability,
    slotsStatus: slotsStatus,
    track: trackProvider,
    config: config,
    isBookingDisabled: isBookingDisabled,
    showWarning: providerTabsEnabled && hasBookingWarning,
    bookingWarning: bookingWarning,
    onClickShowAvailability: onClickShowAvailability,
    locations: providerLocations,
    onTimeSlotsClick: onTimeSlotsClick,
    onViewMoreClick: onViewMoreClick,
    shouldRenderSlotsAsButtons: shouldRenderSlotsAsButtons,
    onAvailabilityTilesLoaded: onAvailabilityTilesLoaded,
    slots: slots,
    bookOnlineUrl: (0, _availability.getAvailTilesBookingUrlForPlacement)(bookOnlineUrl, placementType),
    slotsAriaProps: slotsAriaProps,
    bookingOptionsButton: bookingOptionsButton,
    summaryUrl: summaryUrl
  }), !providerTabsEnabled && /*#__PURE__*/_react.default.createElement(_styles.ProviderLocationsContainer, null, /*#__PURE__*/_react.default.createElement(_providerComponents.ProviderLocations, {
    config: config,
    locations: providerLocations,
    searchSummary: searchSummary,
    track: trackProvider,
    provider: provider,
    bookOnlineUrl: (0, _availability.getAvailTilesBookingUrlForPlacement)(bookOnlineUrl, placementType),
    apptInfo: apptInfo,
    onClickShowAvailability: onClickShowAvailability,
    availabilityTilesMessages: availabilityTilesMessages,
    shouldDisplayAvailability: shouldDisplayAvailabilityWithLocations,
    isAvailabilityReadOnly: isAvailabilityReadOnly,
    availabilityLinkTarget: availabilityLinkTarget,
    onTimeSlotsClick: onTimeSlotsClick,
    onViewMoreClick: onViewMoreClick,
    onAvailabilityTilesLoaded: onAvailabilityTilesLoaded,
    slots: slots,
    slotsStatus: slotsStatus,
    getLocationUrl: getLocationUrl,
    locationCallback: locationCallback,
    locationCTA: locationCTA,
    locationsUrl: locationsUrl,
    locationsCallback: locationsCallback,
    ariaProps: {
      locationsAriaLabeledBy: `view-details-${provider.id}`
    },
    shouldRenderSlotsAsButtons: shouldRenderSlotsAsButtons,
    enableLocationsLimit: isProfileDisabled === false && locationCTA == null
  }))), providerTabsEnabled && /*#__PURE__*/_react.default.createElement(_ProviderCardTabs.ProviderCardTabs, {
    config: providerCardTabsConfig,
    track: track,
    provider: provider,
    customerCode: customerCode,
    productName: productName,
    LocationsProps: LocationsProps,
    shouldDisplayAvailability: shouldDisplayAvailability,
    hasSlots: slots?.length > 0
  }));
};

/* eslint-enable react/prop-types */
ProviderCard.displayName = 'ProviderCard';
var _default = exports.default = ProviderCard;
ProviderCard.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ProviderCard",
  "props": {
    "hasBookingWarning": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "isProfileDisabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    }
  }
};